import { AUTH_HEADER } from '@/core/constants/http-headers'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { ID } from '@/core/types/models/id.model'
import { createTripToJson } from '../resolvers/create-trip-to-json.resolver'
import { createdTripResolver } from '../resolvers/created-trip.resolver'
import { CreateTripResponse } from '../types/api-responses/create-trip-response'
import { BookFormModel } from '../types/models/book-form.model'
import { CreateTripModel } from '../types/models/create-trip.model'

type Input = BookFormModel & CreateTripModel

export function createUpdateTripUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function (tripId: ID, trip: Input) {
    const { token, accountType } = await tokenService.getToken()
    const authHeaders = token ? AUTH_HEADER(token) : {}
    const req = createTripToJson(trip)
    const res = await httpClient.version('v1').addHeaders(authHeaders).put<{
      data: CreateTripResponse
    }>(`/website/${accountType}/trips/${tripId}`, req)

    return createdTripResolver(res.data.data)
  }
}
